import { render, staticRenderFns } from "./SecurityAssignRoles.vue?vue&type=template&id=587a8cd0&scoped=true"
import script from "./SecurityAssignRoles.vue?vue&type=script&lang=js"
export * from "./SecurityAssignRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a8cd0",
  null
  
)

export default component.exports